// extracted by mini-css-extract-plugin
module.exports = {"selectedTab":"MapDataDownloader_selectedTab__2-ldr","tab":"MapDataDownloader_tab__z44iM","tabList":"MapDataDownloader_tabList__33Cgz"};